import { CLINICAL_CONSULTATION_ACTION } from "core/consts";
import { ClinicalConsultationActionType } from "core/types";
import { clinicalConsultation } from "./fragments";

const consultationActionFragment = clinicalConsultation();

const consultationActionFragments: {
  [action in ClinicalConsultationActionType]: string;
} = {
  [CLINICAL_CONSULTATION_ACTION.DELETE_FORM]: consultationActionFragment,
  [CLINICAL_CONSULTATION_ACTION.GENERATE_FORM]: consultationActionFragment,
};

export default consultationActionFragments;
